<div class="drive-duration--icon">
  <mat-icon [svgIcon]="('itinerary.' + medium) || ''"></mat-icon>
</div>

<p driveDurationAction [index]="index" [hostIndex]="hostIndex">
  <ng-content></ng-content>
</p>
